import css from "../../css/listing/layout.module.css";

import React from "react";
import PropTypes from "prop-types";

const Separator = (props) => {
    return (
        <div
            className={css.shadowSeparator}
            style={props.topMargin ? { marginTop: "25px" } : {}}
        >
            <div className={css.shadowSeparatorLine} />
        </div>
    );
};

Separator.propTypes = {
    topMargin: PropTypes.bool,
};

Separator.defaultProps = {
    topMargin: false,
};

export default Separator;
